// extracted by css-extract-rspack-plugin
export default {"MergeQueueSectionText":"MergeQueueSection-module__MergeQueueSectionText__3ok5u9h"};